// extracted by mini-css-extract-plugin
export default {"download":"Download_download__zojLu","text":"Download_text__bzGYJ","buttons":"Download_buttons__S6DuD"};